import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingCart, ClipboardCheck } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { api } from '../lib/api';
import { toast } from 'sonner';

const TAG_STYLES = {
  popular: 'bg-amber-500 text-white',
  nuevo: 'bg-teal-500 text-white',
  oferta: 'bg-red-500 text-white',
  'todo-incluido': 'bg-sky-500 text-white',
};

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  const navigate = useNavigate();
  const [tagLabels, setTagLabels] = useState({});
  const [admState, setAdmState] = useState('abiertas');
  const isAdmission = product.saleMode !== 'libre';

  useEffect(() => {
    api.getScmeSettingsCached().then((s) => setAdmState(s.admissionsState || 'abiertas')).catch(() => {});
  }, []);

  useEffect(() => {
    api.getValueLists().then((lists) => {
      const tags = lists.find((l) => l.id === 'etiquetas')?.values || [];
      setTagLabels(Object.fromEntries(tags.map((t) => [t.id, t.label])));
    }).catch(() => {});
  }, []);

  const onAdd = (e) => {
    e.preventDefault();
    addItem(product);
    toast.success(`${product.name} añadido al carrito`);
  };

  const onRequest = (e) => {
    e.preventDefault();
    navigate(`/admision?curso=${product.slug}`);
  };

  return (
    <Link to={`/producto/${product.slug}`} className="product-card bg-white border border-stone-200 rounded-lg overflow-hidden flex flex-col" data-testid={`product-card-${product.slug}`}>
      <div className="relative h-48 overflow-hidden">
        <img src={product.image} alt={product.name} className="w-full h-full object-cover" loading="lazy" />
        <div className="absolute top-3 left-3 flex gap-2">
          {(product.tags || []).map((t) => (
            <span key={t} className={`text-[10px] font-bold px-2 py-1 rounded ${TAG_STYLES[t] || 'bg-stone-600 text-white'}`}>{tagLabels[t] || t}</span>
          ))}
        </div>
      </div>
      <div className="p-5 flex flex-col flex-1">
        <h3 className="font-bold text-stone-800 mb-1">{product.name}</h3>
        <p className="text-sm text-stone-500 leading-relaxed flex-1">{product.shortDescription}</p>
        <div className="flex items-center justify-between mt-4">
          <div className="flex items-baseline gap-2">
            <span className="text-xl font-black text-stone-800">{product.price.toFixed(2).replace('.', ',')} €</span>
            {product.comparePrice && <span className="text-sm text-stone-400 line-through">{product.comparePrice.toFixed(2).replace('.', ',')} €</span>}
          </div>
          {isAdmission ? (
            <button onClick={onRequest} className="bg-stone-800 hover:bg-stone-700 transition-colors text-white flex items-center gap-1.5 px-3.5 py-2 rounded text-xs font-bold" data-testid={`request-admission-${product.slug}`}>
              <ClipboardCheck className="w-3.5 h-3.5" /> {admState === 'abiertas' ? 'Solicitar admisión' : 'Unirme a la lista de espera'}
            </button>
          ) : (
            <button onClick={onAdd} className="btn-natur flex items-center gap-1.5 px-3.5 py-2 rounded text-xs font-bold" data-testid={`add-to-cart-${product.slug}`}>
              <ShoppingCart className="w-3.5 h-3.5" /> Añadir
            </button>
          )}
        </div>
      </div>
    </Link>
  );
}
